/**
 * Stable CSS class names for E2E — OperationFlagService card.
 */
export const SM_OFS = {
    card: 'service-managment-operation-flag__card',
    row: 'service-managment-operation-flag__row',
    title: 'service-managment-operation-flag__title',
    badge: 'service-managment-operation-flag__badge',
    toggle: 'service-managment-operation-flag-input--toggle',
} as const;

export const smOfsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

